import globalAxios, { type AxiosInstance, type AxiosPromise, type AxiosRequestConfig } from 'axios';
import type { Configuration } from './configuration';
import { BASE_PATH, BaseAPI } from './base';
import type { ResultVo } from './api';

export interface BusinessRoleAdminVo {
  id?: number;
  name: string;
  remark?: string;
  menuIds: number[];
  createTime?: string;
}

export interface BusinessRolePageRequest {
  conditions?: Partial<BusinessRoleAdminVo>;
  pageQuery: {
    page: number;
    pageSize: number;
  };
}

export class BusinessRoleApi extends BaseAPI {

  constructor(
    configuration?: Configuration,
    basePath: string = BASE_PATH,
    axios: AxiosInstance = globalAxios,
  ) {
    super(configuration, basePath, axios);
  }

  public listBusinessRole(
    conditions: Partial<BusinessRoleAdminVo> = {},
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'POST',
      url: `${this.basePath}/businessRole/listBusinessRole`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: { conditions },
    });
  }

  public pageBusinessRole(
    request: BusinessRolePageRequest,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'POST',
      url: `${this.basePath}/businessRole/pageBusinessRole`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: request,
    });
  }

  public addBusinessRole(
    businessRoleAdminVo: BusinessRoleAdminVo,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'POST',
      url: `${this.basePath}/businessRole/addBusinessRole`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: { businessRoleAdminVo },
    });
  }

  public updateBusinessRole(
    businessRoleAdminVo: BusinessRoleAdminVo,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'PUT',
      url: `${this.basePath}/businessRole/updateBusinessRole`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: { businessRoleAdminVo },
    });
  }

  public delBusinessRole(
    businessRoleId: number,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'DELETE',
      url: `${this.basePath}/businessRole/delBusinessRole`,
      params: { businessRoleId },
    });
  }

}
